import { render, staticRenderFns } from "./RecentBookSection.vue?vue&type=template&id=079cd052&scoped=true&"
import script from "./RecentBookSection.vue?vue&type=script&lang=js&"
export * from "./RecentBookSection.vue?vue&type=script&lang=js&"
import style0 from "./RecentBookSection.vue?vue&type=style&index=0&id=079cd052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079cd052",
  null
  
)

export default component.exports